import { getMapPhysicsAssetManifest } from "./map-assets.js";
import { worldPointToRadar } from "./radar-transform.js";
import { throwApex } from "./trajectory.js";
import { defaultGrenadeReachToleranceHu } from "./solve.js";
export function utilityTrajectoryPoints(utility) {
    if (utility.physics &&
        utility.physics.landingErrorHu > defaultGrenadeReachToleranceHu) {
        // Kein physikalisch erreichbarer Weg: Marker und Linie bleiben exakt am
        // gesetzten Ziel, statt zum besten (aber falschen) Fehlwurf zu springen.
        return [utility.start, utility.target];
    }
    const samples = utility.physics?.result.samples;
    const manifest = getMapPhysicsAssetManifest(utility.mapId);
    const transform = manifest?.status === "validated"
        ? manifest.asset.radarTransform
        : manifest?.radarTransform;
    if (samples?.length && transform) {
        return samples.map((sample) => worldPointToRadar(transform, sample.position));
    }
    return [
        utility.start,
        throwApex(utility.start, utility.target, utility.arcHeight),
        utility.target,
    ];
}
export function pointAtUtilityTrajectory(points, progress) {
    if (points.length === 0)
        return { x: 0, y: 0 };
    if (points.length === 1)
        return points[0];
    const clamped = Math.max(0, Math.min(1, progress));
    const position = clamped * (points.length - 1);
    const index = Math.min(points.length - 2, Math.floor(position));
    const local = position - index;
    const start = points[index];
    const end = points[index + 1];
    return {
        x: start.x + (end.x - start.x) * local,
        y: start.y + (end.y - start.y) * local,
    };
}
export function utilityEffectAreas(utility) {
    const areas = utility.physics?.effect?.areas;
    const manifest = getMapPhysicsAssetManifest(utility.mapId);
    const transform = manifest?.status === "validated"
        ? manifest.asset.radarTransform
        : manifest?.radarTransform;
    if (!areas?.length || !transform)
        return null;
    const origin = worldPointToRadar(transform, utility.physics.effect.origin);
    return areas.map((area) => ({
        points: area.boundary.map((point) => {
            const projected = worldPointToRadar(transform, point);
            return { x: projected.x - origin.x, y: projected.y - origin.y };
        }),
        intensity: area.intensity,
    }));
}
